import { defineMessages } from 'react-intl';

export default defineMessages({
  AvailableCreditModalCancelBtn: {
    defaultMessage: 'cancel',
    description: 'Cancel button',
    id: 'availableCreditModalCancelBtn',
  },
  AvailableCreditModalConfirmBtn: {
    defaultMessage: 'Use credits',
    description: 'Confirm button',
    id: 'availableCreditModalConfirmBtn',
  },
  AvailableCreditModalMessage2: {
    defaultMessage: 'The amount deducted from your credit pool will' + ' be based on the days remaining in the month.',
    description: 'Confirm message 2nd row',
    id: 'availableCreditModalMessage2',
  },
  AvailableCreditModalMessageError: {
    defaultMessage: 'Operation failed. Please try again later.',
    id: 'availableCreditModalMessageError',
  },
  AvailableCreditModalMessageSuccess: {
    defaultMessage: 'Operation successful.',
    id: 'availableCreditModalMessageSuccess',
  },
  AvailableCreditModalModalTitle: {
    defaultMessage: 'Use credits',
    description: 'Modal title',
    id: 'availableCreditModalModalTitle',
  },
});
